import { Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { env } from '../config/env';
import { User } from '../models/types';

interface TokenResponse {
  access_token: string;
  refresh_token: string;
}

@Injectable({ providedIn: 'root' })
export class AuthService {
  user = signal<User | null>(null);

  constructor(private readonly http: HttpClient) {}

  get token(): string | null {
    return localStorage.getItem('access_token');
  }

  isAuthenticated(): boolean {
    return !!this.token;
  }

  async login(email: string, password: string): Promise<void> {
    const data = await firstValueFrom(
      this.http.post<TokenResponse>(`${env.apiUrl}/api/v1/auth/login`, { email, password }),
    );
    localStorage.setItem('access_token', data.access_token);
    localStorage.setItem('refresh_token', data.refresh_token);
    await this.loadMe();
  }

  async loadMe(): Promise<User | null> {
    try {
      const me = await firstValueFrom(this.http.get<User>(`${env.apiUrl}/api/v1/auth/me`));
      this.user.set(me);
      return me;
    } catch {
      this.user.set(null);
      return null;
    }
  }

  logout(): void {
    localStorage.clear();
    this.user.set(null);
  }
}
